<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0038 2.05151C6.51292 2.05151 2.05371 6.51025 2.05371 12.0022C2.05371 17.4941 6.51292 21.9528 12.0038 21.9528C17.4961 21.9528 21.9554 17.4941 21.9554 12.0022C21.9554 6.51025 17.4961 2.05151 12.0038 2.05151ZM12.0038 3.63617C16.6221 3.63617 20.3704 7.38484 20.3704 12.0022C20.3704 16.6194 16.6221 20.3682 12.0038 20.3682C7.38689 20.3682 3.63866 16.6194 3.63866 12.0022C3.63866 7.38484 7.38689 3.63617 12.0038 3.63617Z"
      fill="#141414"
    />
    <path
      d="M10.7464 13.2932C10.7464 13.777 11.0429 14.1515 11.6047 14.1515C12.1352 14.1515 12.3381 13.8394 12.5254 13.3869C12.697 12.747 12.9467 12.4818 13.6957 11.92C14.6632 11.2022 15.3187 10.5467 15.3187 9.37636C15.3187 7.67542 13.9142 6.62988 11.9168 6.62988C10.84 6.62988 9.99734 6.91077 9.45117 7.37892C8.98302 7.78465 8.68652 8.31522 8.68652 8.81458C8.68652 9.23592 8.95181 9.57923 9.43556 9.57923C9.76327 9.57923 9.93492 9.43879 10.1846 9.12668C10.5435 8.50248 11.0429 8.22159 11.7763 8.22159C12.619 8.22159 13.2744 8.72095 13.2744 9.45439C13.2744 10.1254 12.8687 10.4999 12.1352 11.0773C11.1053 11.8888 10.7464 12.3881 10.7464 13.2932ZM10.4499 16.305C10.4499 16.9292 10.9649 17.3817 11.6047 17.3817C12.2289 17.3817 12.7594 16.9292 12.7594 16.305C12.7594 15.6652 12.2289 15.2282 11.6047 15.2282C10.9649 15.2282 10.4499 15.6652 10.4499 16.305Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Question'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
